// extracted by mini-css-extract-plugin
export var dismissOverlay = "_bx-b";
export var interactivePassthrough = "_bx-3";
export var modal = "_bx-d";
export var modalBackdrop = "_bx-c";
export var modalBody = "_bx-j";
export var modalDescription = "_bx-m";
export var modalEnter = "_bx-e";
export var modalFooter = "_bx-n";
export var modalHeaderText = "_bx-h";
export var modalIconCircle = "_bx-i";
export var modalIconHeader = "_bx-g";
export var modalImage = "_bx-f";
export var modalSectionLabel = "_bx-k";
export var modalTitle = "_bx-l";
export var pulse = "_bx-1";
export var pulseBorder = "_bx-2";
export var spotlight = "_bx-0";
export var tooltip = "_bx-4";
export var tooltipButtons = "_bx-9";
export var tooltipDescription = "_bx-6";
export var tooltipFooter = "_bx-7";
export var tooltipInteractivePill = "_bx-a";
export var tooltipStepIndicator = "_bx-8";
export var tooltipTitle = "_bx-5";